import React from 'react';
import { motion, Reorder } from 'framer-motion';
import QuizQuestionTimer from './QuizQuestionTimer';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';

export default function OrderQuestion({ message, question, endedEarly, reportAnswer, isLocked, setIsLocked }) {
  const { Answers, Description } = question;
  const {
    timetoken,
    message: {
      data: { time },
    },
  } = message;

  const [answers, setAnswers] = React.useState([]);

  const onQuestionEnd = () => {
    setIsLocked(true);
  };

  const onQuestionAlreadyEnded = () => {
    setIsLocked(true);
  };

  React.useEffect(() => {
    setAnswers(Answers);
  }, []);

  const onDragEnd = () => {
    if (CrowdHub_App.INSTANCE.CurrentUser.IsLoggedIn() == true) {
      const postAnswers = answers.map((answer, i) => ({
        answer: answer.answer_id,
        question: question.Id,
        response: '',
        intoption: i,
      }));
      CrowdHub_App.INSTANCE.mServices.SyncQuizQuestionAnswers(
        question.Id,
        postAnswers,
        () => {},
        error => {
          console.error(error);
        },
      );
    }
  };

  let ordersJSX;

  if (isLocked) {
    ordersJSX = (
      <ul className={`order_items`}>
        {answers.map(answer => (
          <li key={`${timetoken}_${answer.answer_id}`} value={answer} className={`order_item`}>
            <div className={`order_answer`}>{answer.answer_answer}</div>
            <div className={`order_icon`}>
              <i className={FontAwesomeConfigurations.ICON_GRIP_VERTICAL}></i>
            </div>
          </li>
        ))}
      </ul>
    );
  } else {
    ordersJSX = (
      <Reorder.Group axis="y" values={answers} onReorder={setAnswers} className={`order_items`}>
        {answers.map((answer, i) => (
          <motion.div
            variants={answerVariants}
            custom={i}
            initial={'hidden'}
            animate={`show`}
            key={`${timetoken}_${answer.answer_id}`}
          >
            <Reorder.Item className={`order_item`} value={answer} onDragEnd={onDragEnd}>
              <div className={`order_answer`}>{answer.answer_answer}</div>
              <div className={`order_icon`}>
                <i className={FontAwesomeConfigurations.ICON_GRIP_VERTICAL}></i>
              </div>
            </Reorder.Item>
          </motion.div>
        ))}
      </Reorder.Group>
    );
  }

  return (
    <div
      className={`question_question question_container question_message`}
      id={`${App.INSTANCE.CurrentUser.Id}${message.timetoken}`}
    >
      <div className={`question ${isLocked ? 'locked' : ''}`}>
        <div className={`description`} dangerouslySetInnerHTML={{ __html: Description }} />
        <div className={`answers`} initial={`hidden`} animate={`show`}>
          {ordersJSX}
        </div>
        <QuizQuestionTimer
          questionTime={timetoken}
          questionDuration={time}
          onQuestionEnd={onQuestionEnd}
          onQuestionAlreadyEnded={onQuestionAlreadyEnded}
          endedEarly={endedEarly}
        />
      </div>
    </div>
  );
}

const answerVariants = {
  hidden: { opacity: 0, x: 50 },
  show: i => ({ opacity: 1, x: 0, transition: { delay: i * 0.15 } }),
};
